import React from 'react';
import { createPortal } from 'react-dom';
import { FONT_SANS } from '../../views/landing/landingData';

/**
 * Portal root for global overlays (toasts, confirm dialogs).
 *
 * The design tokens (`--hv-*`) are scoped under `.hv-root[data-hv-theme]`, so
 * anything rendered straight into <body> would lose them. This wrapper is its
 * own `.hv-root`, mirroring the theme of whatever page is on screen, so the
 * overlays always match the page (light/dark) without threading theme props
 * through every provider.
 */
export const currentTheme = (): 'light' | 'dark' =>
    document.querySelector('.hv-root[data-hv-theme]')?.getAttribute('data-hv-theme') === 'dark' ? 'dark' : 'light';

export const HvLayer: React.FC<{ children: React.ReactNode }> = ({ children }) =>
    createPortal(
        <div className="hv-root" data-hv-theme={currentTheme()} style={{ fontFamily: FONT_SANS, color: 'var(--hv-ink)', WebkitFontSmoothing: 'antialiased' }}>
            {children}
        </div>,
        document.body,
    );
